module.exports = __webpack_public_path__ + "static/image/social-related.svg?35ec653bdbb28f88946d8dc6254c4769";